import api, { STREAM_HOST } from '../../api';

const makeViewerUrl = (stream) => stream.viewerUrl || `https://${STREAM_HOST}/${stream.key}/`;

const state = {
  streams: [],
  selected: null,
  mtxStatus: null,
  loading: false,
  error: null,
  usingFallback: false,
};

const getters = {
  streams: (state) => state.streams.map((stream) => ({ ...stream, viewerUrl: makeViewerUrl(stream) })),
  selected: (state, getters) => state.selected || getters.streams[0] || null,
  usingFallback: (state) => state.usingFallback,
  mtxStatus: (state) => state.mtxStatus,
};

const mutations = {
  setStreams(state, streams) {
    state.streams = streams || [];
    state.usingFallback = false;
  },
  setSelected(state, stream) {
    state.selected = stream ? { ...stream, viewerUrl: makeViewerUrl(stream) } : null;
  },
  setLoading(state, value) { state.loading = value; },
  setError(state, value) { state.error = value; },
  setMtxStatus(state, value) { state.mtxStatus = value; },
};

const actions = {
  async fetchStreams({ commit }) {
    commit('setLoading', true);
    try {
      const { data } = await api.get('/api/streams');
      commit('setStreams', data.streams || []);
      commit('setError', null);
    } catch (error) {
      commit('setStreams', []);
      if (error.response?.status === 401) {
        commit('setError', 'Сессия устарела. Выйдите и войдите заново, либо создайте первого администратора.');
      } else {
        commit('setError', 'Список потоков сейчас недоступен.');
      }
    } finally {
      commit('setLoading', false);
    }
  },
  async fetchMtxStatus({ commit }) {
    try {
      const { data } = await api.get('/api/mtx/paths');
      commit('setMtxStatus', data);
    } catch (error) {
      commit('setMtxStatus', null);
    }
  },
};

export default { namespaced: true, state, getters, mutations, actions };
